import { render, staticRenderFns } from "./ResourceEditor.vue?vue&type=template&id=0ce4d4fe"
import script from "./ResourceEditor.vue?vue&type=script&lang=js"
export * from "./ResourceEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports